import { useCallback } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { kubernetesProxyApiRef } from '../../../api/types.esm.js';

const usePodDelete = () => {
  const kubernetesProxyApi = useApi(kubernetesProxyApiRef);
  const deletePod = useCallback(
    async (podScope) => {
      return await kubernetesProxyApi.deletePod({
        podName: podScope.podName,
        namespace: podScope.podNamespace,
        clusterName: podScope.cluster.name
      });
    },
    [kubernetesProxyApi]
  );
  return deletePod;
};

export { usePodDelete };
//# sourceMappingURL=usePodDelete.esm.js.map
